import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AppComponent} from '../app.component';
import {MatDialog, MatSnackBar} from '@angular/material';
import {QueryBuilderConfig} from 'angular2-query-builder';
import {ActivatedRoute, Router} from '@angular/router';
import {HeadersComponent} from '../devex/headers/headers.component';
import {ExecutorComponent} from '../executor/executor.component';
import {Observable} from 'rxjs';
import {ICategory} from '../crudapi/crudapi.component';
import {FormControl} from '@angular/forms';
import {environment} from '../../environments/environment';
import {KongService} from '../kong.service';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {PartnerOnboardComponent} from '../partner-onboard/partner-onboard.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ListenerService} from '../listener.service';
import {DevexComponent} from '../devex/devex.component';
import {SqlqueryListenerService} from '../sqlquery-listener.service';
import exportFromJSON from 'export-from-json';
import {Location} from '@angular/common';
import * as CryptoJS from 'crypto-js';
import {WebsocketService} from '../websocket.service';
import {AuditListenerService} from '../audit-listener.service';
import {DependencyCheckComponent} from '../new-blockly/new-blockly.component';
import {TestReportComponent} from '../testsuite/test-report/test-report.component';
import {AccountInfoService} from '../user/account-info.service';
import {AuditLogService} from '../audit-log.service';

declare let $;
const incr = 5;

@Component({
    selector: 'app-query-builder-base',
    templateUrl: './query-builder-base.component.html',
    styleUrls: ['./query-builder-base.component.scss']
})
export class QueryBuilderBaseComponent implements OnInit {
    attributeList: any;
    attributeWithType: any;
    // substring,replace, round, isnull
    functionList = ['len', 'upper', 'lower', 'attributes'];
    operatorList = ['=', '<>', '<=', '>=', '>', '<'];
    ruleset = {
        'condition': 'and',
        'rules': [
            {
                'attributes': null,
                'functions': null,
                'operators': null,
                'values': null
            }]
    };
    queryRuleset = {
        'condition': 'and',
        'rules': [
            {
                'field': null,
                'type': null,
                'function': null,
                'operator': null,
                'value': null
            }]
    };

    joinRuleset = {
        'condition': 'and',
        'rules': [
            {
                'field': null,
                'function': null,
                'operator': null,
                'value': null
            }]
    };
    conditionType = 'query';

    title = 'app';
    code = '';
    showNextPanel = false;
    defaultDatabase = 'default';
    themeList = [{'key': 'vs', 'value': 'Visual Studio'}, {'key': 'vs-dark', 'value': 'Visual Studio Dark'}, {
        'key': 'hc-black',
        'value': 'High Contrast Black'
    }];
    theme = 'vs-dark';
    options = {
        theme: this.theme,
        language: 'sql',
        automaticLayout: true
    };
    @Input() enableEditor = false;
    database: string;
    // databaseSelected: any;
    tableSelected: string;
    databaseList = [];
    dbItem: any;
    dbs: any;
    entityList: any;
    fields: any;
    tableList: any;
    enablequery: boolean;
    config: QueryBuilderConfig;
    attribute: string;
    databaseName: string;
    selectedIndex: any;
    filterData: any[];
    settings = {text: 'Select attribute(s) to search instantly'};
    itemList: any[];
    error = false;
    errorMessage: string;
    searchText: any;

    logVisible = false;
    refreshLogCount = 0;
    pubSubTopic: any;
    logComponentRefresh = false;
    apiDeploymentLogs = [];
    currentMessage: any;
    apiType = 'SQLQUERY';
    logTimeStamp: any;
    gatewaySettings: any;
    gatewayControl = new FormControl([]);


    responseCode: any;
    responseData: any;
    responseItems: any;
    responses: any;
    databaseFlag = false;
    responseError: any;
    responseTimestamp: any;
    responseHeaders: any;
    responseTime: any;
    userView = 'json';
    columns: string[] = [];
    itemLength: any;
    showDialogOnNonWebsocketConnection: any;


    authModel = {
        'authType': '',
        'authAttributes': {}
    };
    headers = [];
    @Input() mockResponses = [];

    queryParams = [];
    requestBody = {};
    prerequisites: any;
    responseAttributes = [];

    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    scopeSelected = 'public';
    description: string;
    executorCategory: string;
    @Input() executor_name: string;
    @Input() selectedVersion: string;
    selectedExecutorType: string;
    selectedExecutor: string;
    executor_display_name: string;
    gatewayUrl: any;
    gatewayFullUrl: string;
    executorModel: any;
    executorModelPayload: any;
    @Input() partner = localStorage.getItem('partner');
    partnerKey = localStorage.getItem('partnerKey');
    @Input() account_id = localStorage.getItem('account');
    @Input() showButtons = true;
    @Input() executorModelAvailable = false;
    @Input() executorModelInput: any;
    @Input() disableDatabase = false;
    @Input() fromCopyOrPromote = false;
    @Input() targetDatabases = [];
    @Input() targetPartner: any;
    @Input() targetAccount: any;
    @Input() targetPkey: any;
    @Input() retrieveExecutorFromRouteParams = true;
    @Output() onSavingExecutor: EventEmitter<any> = new EventEmitter<any>();
    // @Input() inputSchema: any;
    apiKey = localStorage.getItem('apikey');
    executor: any;
    pathParams: any;
    save: boolean;
    filteredOptions: Observable<ICategory[]>;
    myControl = new FormControl();
    destroy: any;
    Blocks = [];
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    progress = 0;
    progressMessage: string;
    editFlag: boolean;
    loading = false;
    hintText = 'Hints: Test your SQL Query before creating an API. You can add query parameters prefixed with a space followed by ":" (" :param1") in Query Editor and set value for the same in Query Parameter section. Use ";" as delimiter while executing multiple SQL Statements as SQL Script. You can use Inherit to use connections from other partner environments.';
    @ViewChild(ExecutorComponent) executorComp: ExecutorComponent;
    @ViewChild('aceEditor') editor;
    private responseObject: any;
    private erroResponse: any;
    eventNameForAudit = '';
    previousSavedData: any;

    origEntity: string;
    origVersion: string;
    cloneable = false;
    previouslyDeployedData: any;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIAlreadyPresent = true;
    orig_executor_name: any;
    orig_executor: any;
    orig_executor_version: any;
    componentLoading = true;
    selectedDatatypeFilter: string;
    isSelectedDatabaseNatureNoSQL: any;
    databases: any;
    fromHistory = false;
    action: any;
    eventNameForAuditLog = '';
    eventLabelForAuditLog = '';
    redeployNewExecutor = false;
    isSqlPresent = false;

    @Input() isApiDiscovery: boolean;
    dependencyApis: any;
    testLoading = false;
    testSuiteResponse: any;

    constructor(
        private settingComp: PartnerOnboardComponent,
        private router: Router,
        private confPost: ConfService,
        private _service: ConnecttocrudService,
        private appComp: AppComponent,
        private route: ActivatedRoute,
        private kongService: KongService,
        public platform: LeftpanelComponent,
        private auditLog: AuditLogService,
        public accountInfoService: AccountInfoService,
        private websocketService: WebsocketService,
        private leftPanelDataListener: ListenerService,
        private auditListenerService: AuditListenerService,
        private SQLQueryListenerInstance: SqlqueryListenerService,
        private dialog: MatDialog,
        private location: Location) {


    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.editFlag === false && this.location['_platformLocation'].location.pathname === '/querybuilder') {
            this.confPost.getAPIExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/querybuilder?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                }
            });
        }
    }

    hasViewPagePermissions() {
        if (this.editFlag === true) {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_QUERY_BUILDER_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]));
            } else {
                return this.platform.hasPermissions(['EDIT_QUERY_BUILDER_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
            }
        } else {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_QUERY_BUILDER_API']));
            } else {
                return this.platform.hasPlatformPermission('CREATE_QUERY_BUILDER_API');
            }
        }
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.websocketService.isOpen()) {
            // that.setInterval(blockEnd, true);
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    hasSavePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['SAVE_QUERY_BUILDER_API', 'save:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('SAVE_QUERY_BUILDER_API');
        }
    }

    hasCopyPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['COPY_QUERY_BUILDER_API', 'copy:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('COPY_QUERY_BUILDER_API');
        }
    }

    async getDatabasesFilter(val) {
        return new Promise(async (resolve, reject) => {
            if (this.platform.databases !== null && this.platform.databases !== undefined) {
                await this.platform.updateIsNoSQLForMongo(this.platform.databases);
                this.databases = this.platform.databases;
                this.databases.filter(items => {
                    if (items.database_name === val) {
                        this.selectedDatatypeFilter = items.database_type;
                        if (items.hasOwnProperty('is_nosql')) {
                            this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                        }
                    }
                });
                resolve('success');
            } else {
                await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                        await this.platform.updateIsNoSQLForMongo(databases);
                        this.databases = this.platform.databases;
                        this.databases.filter(items => {
                            if (items.database_name === val) {
                                this.selectedDatatypeFilter = items.database_type;
                                if (items.hasOwnProperty('is_nosql')) {
                                    this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                                }
                            }
                        });
                        resolve('success');
                    },
                    error => {
                        this.platform.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        reject(error);
                    });
            }
        });
    }

    async copyTo() {
        if (this.executor && this.executor !== null && this.executor !== undefined) {
            const metaSchema = JSON.parse(JSON.stringify(this.executor));
            await this.getDatabasesFilter(this.database);
            metaSchema['databaseType'] = this.selectedDatatypeFilter;
            this.platform.copyToPartner(this.executor['executor_name'], this.executor['executor_version'], 'SQLQUERY', metaSchema);
        }
    }

    addRule(data) {
        const newRule = {
            'attributes': null,
            'functions': null,
            'operators': null,
            'values': null
        };
        data.rules.push(newRule);
    }

    async getDatabaseObject() {
        const toPushKeys = ['API-PLATFORM-PARTNER', 'API-PLATFORM-PARTNER-KEY', 'CONNECTION-NAME'];
        if (this.database === 'inherit') {
            // this.executorModel = {
            //   'database': {
            //     'databaseDetails': {
            //       'database_name': this.database
            //     },
            //     'shash': CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex),
            //     'ralam': CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
            //   },
            //   'query': this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null,
            // };

            this.executorModel = {
                'database': {
                    'database_name': this.database,
                },
                'query': this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null,
                'paramPrefixSubString': ' :'
            };
            for (const pushKey of toPushKeys) {
                this.executorComp.headers.push({key: pushKey, value: '', description: ''});
            }
        } else {
            let headers = [];
            let executorCompHeaders = [];
            executorCompHeaders = this.executorComp.headers;
            for (let i = 0; i < executorCompHeaders.length; i++) {
                let flag = false;
                const header = executorCompHeaders[i];
                toPushKeys.forEach(pushKey => {
                    if (header && header.hasOwnProperty('key')) {
                        if (header['key'] === pushKey) {
                            flag = true;
                        }
                    }
                });
                if (flag === false) {
                    headers.push(header);
                }
            }
            this.executorComp.headers = headers;
            if (!this.fromCopyOrPromote) {
                await this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.database).toPromise().then(db => {
                    this.executorModel = {
                        'database': {},
                        'query': this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null,
                        'paramPrefixSubString': ' :'
                    };
                    if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                        this.executorModel.database['database_name'] = db['database_name'];
                        this.executorModel.database['database_type'] = db['database_type'];
                    }
                }, error => {
                    this.loading = false;
                    this.closeNonWSDialogBox();
                    this.platform.handleErrorGracefully(error, 'Please make sure you have selected a valid database.');
                });
            } else {
                await this.confPost.getDatabaseForPartnerWithPkey(this.targetPartner, this.targetAccount, this.database, this.targetPkey).toPromise().then(db => {
                    this.executorModel = {
                        'database': {},
                        'query': this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null,
                        'paramPrefixSubString': ' :'
                    };
                    if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                        this.executorModel.database['database_name'] = db['database_name'];
                        this.executorModel.database['database_type'] = db['database_type'];
                    }
                }, error => {
                    this.loading = false;
                    this.closeNonWSDialogBox();
                    this.platform.handleErrorGracefully(error, 'Please make sure you have selected a valid database.');
                });
            }
        }
    }

    saveEmitAPI() {
        this.executorModelPayload = this.getAPIExecutorModelForSQLQuery(this.executorModel);
        this.executorModelPayload.executors[0].query = this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null;
        this.onSavingExecutor.emit(this.executorModelPayload);
    }

    emitAPI() {
        this.onSavingExecutor.emit(this.executorModel);
    }


    getTableList(val) {
        this.tableList = [];
        this.entityList = [];
        this.dbs.databases.filter(items => {
            if (items.database_name === val.db_name) {
                items.accounts.forEach((accounts) => {
                    accounts.entities.forEach((entities) => {
                        this.entityList.push(entities);
                        this.tableList.push(entities.entityname);
                    });
                });
            }
        });
    }

    getAttributeList() {
        const that = this;
        this.enablequery = true;
        // that.config.fields = {};
        const tablelist = this.tableSelected;
        this.attributeList = [];
        this.attributeWithType = [];
        this.entityList.filter(items => {
            if (tablelist.indexOf(items.entityname) > -1) {
                items.attributes.forEach((attributes) => {
                    // that.config.fields[attributes.attributeName]
                    //     = {name: attributes.attributeName , type:
                    //       (attributes.type.toLowerCase() == 'integer' ? 'number' :
                    //           (attributes.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
                    this.attributeList.push(attributes.attributeName);
                    this.attributeWithType.push({name: attributes.attributeName, type: attributes.type.toLowerCase()});
                });
            }
        });
    }

    getProjectionData(data) {
        const result = {};
        result['include_fields'] = [];
        result['exclude_fields'] = [];
        data.forEach((proj) => {
            const sun_res = {};
            sun_res['table_name'] = '';
            sun_res['table_alias'] = '';
            sun_res['attribute'] = proj;
            sun_res['attribute_alias'] = '';
            sun_res['aggregate_function'] = '';
            result['include_fields'].push(sun_res);
        });
        return result;
    }

    getCollectionsData(data) {
        const result = {};
        result['table_name'] = data;
        return result;
    }

    getAttributeWait() {
        // this.enableQuerySection = true;
        this.enablequery = false;
        const that = this;
        setTimeout(function () {
            that.getAttributeList();
        }, 500);

    }

    addRuleSet(data) {

        const newRuleSet = {
            'condition': 'and',
            'rules': [
                {
                    'attributes': null,
                    'functions': null,
                    'operators': null,
                    'values': null
                }]
        };
        data.rules.push(newRuleSet);
    }

    checkFilter() {
        if (this.filterData === null || this.filterData === undefined || this.filterData === []) {
            this.searchText = '';
            alert('Please select and attribute to filter.');
        }
    }

    removeRule(data, i) {
        data.splice(i, 1);
    }

    onInit(editor) {
        let line = editor.getPosition();

        // editor.addCommand(monaco.KeyCode.Enter, function(accessor) {
        //   editor.trigger('', 'type', { text: ' ' });
        // }, '!suggestWidgetVisible && !renameInputVisible && !inSnippetMode && !quickFixWidgetVisible');
        //  this.enableMonacoEditor = true;
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        if (this.location['_platformLocation'].location.pathname === '/querybuilder' || this.isApiDiscovery) {
            this.route.queryParams
                .subscribe(async params => {
                    this.cloneable = false;
                    this.editFlag = false;
                    this.fromHistory = false;
                    if (this.retrieveExecutorFromRouteParams) {
                        if (params.clone && params.clone === 'true') {
                            this.cloneable = true;
                            this.executor = this.platform.cloneableData;
                            if (this.executor) {
                                this.executor_name = this.executor.executor_name;
                                this.orig_executor_name = this.platform.cloneableData.executor_name;
                                this.orig_executor_version = this.platform.cloneableData.executor_version;
                                this.selectedVersion = this.executor.executor_version;
                                this.selectedExecutorType = this.executor.executor_type;
                                this.selectedExecutor = this.executor.executor_method_type;
                                this.executorCategory = this.executor.executor_category;
                                this.executor_display_name = this.executor.executor_display_name;
                                this.scopeSelected = this.executor.scopeOfAccess;
                                this.description = this.executor.executor_description;
                                this.queryParams = this.executor.queryParams;
                                this.pathParams = this.executor.pathParams;
                                this.headers = this.executor.headers;
                                this.mockResponses = this.executor.mockResponses;
                                this.requestBody = this.executor.requestBody;
                                this.executorModel = this.executor.executors[0];
                                if (this.executorModel.database.hasOwnProperty('databaseDetails')) {
                                    this.database = this.executorModel.database.databaseDetails.database_name; //{'db_name': this.executorModel.database.database_name, 'db_type': this.executorModel.database.database_type};
                                } else {
                                    this.database = this.executorModel.database.database_name;
                                }
                                await this.getDatabaseList();
                                let isCloneableDBPresent = false;
                                this.databaseList.forEach((database) => {
                                    if (database) {
                                        if (database === this.database) {
                                            isCloneableDBPresent = true;
                                        }
                                    }
                                });
                                if (isCloneableDBPresent === false) {
                                    this.databaseList.push({
                                        'db_name': this.executorModel.database.database_name,
                                        'db_type': this.executorModel.database.database_type
                                    });
                                }
                                // this.databaseSelected = this.database.db_name;
                                this.code = this.executorModel.query;

                                if (this.executor.responseAttributes !== null) {
                                    this.responseAttributes = this.executor.responseAttributes;
                                }
                            } else {
                                this.router.navigateByUrl('/querybuilder');
                            }
                        } else if (params.timestamp && params.timestamp !== '') {
                            this.fromHistory = true;
                            await this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + params.partner + '&account=' + params.account + '&at=' + params.timestamp).toPromise().then(response => {
                                if (response && response[0]) {
                                    if (response[0]['executor']) {
                                        const executor = response[0]['executor'];
                                        this.executor_name = executor.executor_name;
                                        this.orig_executor_name = response[0]['executor'].executor_name;
                                        this.orig_executor_version = response[0]['executor'].executor_version;
                                        this.selectedVersion = executor.executor_version;
                                        this.selectedExecutorType = executor.executor_type;
                                        this.selectedExecutor = executor.executor_method_type;
                                        this.executorCategory = executor.executor_category;
                                        this.executor_display_name = executor.executor_display_name;
                                        this.description = executor.executor_description;
                                        this.queryParams = executor.queryParams;
                                        this.pathParams = executor.pathParams;
                                        this.headers = executor.headers;
                                        this.mockResponses = executor.mockResponses;
                                        this.requestBody = executor.requestBody;
                                        this.scopeSelected = executor.scopeOfAccess;
                                        this.gatewaySettings = executor.gatewaySettings;
                                        if (this.gatewaySettings) {
                                            const gateways = [];
                                            if (this.gatewaySettings) {
                                                if (this.gatewaySettings.length > 0) {
                                                    for (const gateway of this.gatewaySettings) {
                                                        gateways.push(gateway['name']);
                                                    }
                                                }
                                            }
                                            if (gateways.length === 0) {
                                                gateways.push('default');
                                            }
                                            this.gatewayControl.setValue(gateways); // To trigger change detection
                                        }
                                        this.executorModel = executor.executors[0];
                                        if (this.executorModel.database.hasOwnProperty('databaseDetails')) {
                                            this.database = this.executorModel.database.databaseDetails.database_name; //{'db_name': this.executorModel.database.database_name, 'db_type': this.executorModel.database.database_type};
                                        } else {
                                            this.database = this.executorModel.database.database_name;
                                        }
                                        // {'db_name': this.executorModel.database.database_name, 'db_type': this.executorModel.database.database_type};
                                        // this.databaseSelected = this.database.db_name;
                                        this.code = this.executorModel.query;
                                        if (executor.responseAttributes !== null) {
                                            this.responseAttributes = executor.responseAttributes;
                                        }
                                        if (response[0]['action'] === 'CREATE') {
                                            this.editFlag = false;
                                        } else {
                                            this.editFlag = true;
                                        }
                                    } else {
                                        this.platform.openSnackBar('Error in retrieving the required version of the API.', 'Error', {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                        this.router.navigateByUrl('/querybuilder');
                                    }
                                } else {
                                    this.platform.openSnackBar('Error in retrieving the required version of the API.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    this.router.navigateByUrl('/querybuilder');
                                }
                            }, error => {
                                this.platform.handleErrorGracefully(error, 'Error in retrieving the required version of the API. Please try again after sometime.');
                                this.router.navigateByUrl('/querybuilder');
                            });
                        } else {
                            if (params.partner != null && params.account !== null) {
                                this.partner = params.partner;
                                this.account_id = params.account;

                                if (!this.fromCopyOrPromote) {
                                    this.executor_name = params.entity;
                                    this.selectedVersion = params.version;
                                }

                                if (params.entity != null && params.version || this.fromCopyOrPromote) {
                                    this.editFlag = true;
                                    this.orig_executor_name = params.entity;
                                    this.orig_executor_version = params.version;
                                    this.origEntity = params.entity;
                                    this.origVersion = params.version;
                                    this.partner = params.partner;
                                    this.account_id = params.account;
                                    this.showNextPanel = false;
                                    this.save = false;

                                    Promise.resolve(this.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executor_name, this.selectedVersion)).then(resp => {
                                    }, error => {
                                        this.platform.handleErrorGracefully(error, 'Error in retrieving the API for the account by name and version. Please try again after sometime.');
                                    });
                                }
                            } else if (this.isApiDiscovery && this.partner && this.account_id && this.executor_name && this.selectedVersion) {
                                this.editFlag = true;
                                this.orig_executor_name = this.executor_name;
                                this.orig_executor_version = this.selectedVersion;
                                this.origEntity = this.executor_name;
                                this.origVersion = this.selectedVersion;
                                this.showNextPanel = false;
                                this.save = false;
                                this.fromCopyOrPromote = false;

                                Promise.resolve(this.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executor_name, this.selectedVersion)).then(resp => {
                                }, error => {
                                    this.platform.handleErrorGracefully(error, 'Error in retrieving the API for the account by name and version. Please try again after sometime.');
                                });
                            } else {
                                this.executor = undefined;
                                this.executor_name = undefined;
                                this.selectedVersion = undefined;
                                this.selectedExecutorType = undefined;
                                this.selectedExecutor = undefined;
                                this.executorCategory = undefined;
                                this.executor_display_name = undefined;
                                this.description = undefined;
                                this.queryParams = [];
                                this.pathParams = undefined;
                                this.headers = [];
                                this.mockResponses = [];
                                this.requestBody = {};
                                this.executorModel = undefined;
                                this.database = undefined;
                                // this.databaseSelected = this.database.db_name;
                                this.code = '';
                                this.showNextPanel = false;
                                this.save = false;
                            }
                        }
                    } else {
                        if (this.partner && this.account_id && this.executor_name && this.selectedVersion) {
                            Promise.resolve(this.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executor_name, this.selectedVersion)).then(resp => {
                            }, error => {
                                this.platform.handleErrorGracefully(error, 'Error in retrieving the API for the account by name and version. Please try again after sometime.');
                            });
                        } else {
                            this.executor = undefined;
                            this.executor_name = undefined;
                            this.selectedVersion = undefined;
                            this.selectedExecutorType = undefined;
                            this.selectedExecutor = undefined;
                            this.executorCategory = undefined;
                            this.executor_display_name = undefined;
                            this.description = undefined;
                            this.queryParams = [];
                            this.pathParams = undefined;
                            this.headers = [];
                            this.mockResponses = [];
                            this.requestBody = {};
                            this.executorModel = undefined;
                            this.database = undefined;
                            this.code = '';
                            this.showNextPanel = false;
                            this.save = false;
                        }
                    }
                });
        }

        if (this.executorModelAvailable) {
            const executor = JSON.parse(JSON.stringify(this.executorModelInput));
            this.executor_name = executor.executor_name;
            this.orig_executor_name = executor.executor_name;
            this.orig_executor_version = executor.executor_version;
            this.selectedVersion = executor.executor_version;
            this.selectedExecutorType = executor.executor_type;
            this.selectedExecutor = executor.executor_method_type;
            this.executorCategory = executor.executor_category;
            this.executor_display_name = executor.executor_display_name;
            this.description = executor.executor_description;
            this.queryParams = executor.queryParams ? executor.queryParams : [];
            this.pathParams = executor.pathParams ? executor.pathParams : [];
            this.headers = executor.headers;
            this.mockResponses = executor.mockResponses;
            this.requestBody = executor.requestBody;
            this.scopeSelected = executor.scopeOfAccess ? executor.scopeOfAccess : executor.executor_scope;
            if (executor.executors) {
                this.executorModel = executor.executors[0];
                if (this.executorModel.database.hasOwnProperty('databaseDetails')) {
                    this.database = this.executorModel.database.databaseDetails.database_name;
                } else {
                    this.database = this.executorModel.database.database_name;
                }
                this.code = this.executorModel.query;
            }
        }


        this.databaseList.push({'db_name': 'inherit', 'db_type': 'inherit'});
        // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
        this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        this.gatewayFullUrl = 'https://' + this.gatewayUrl;

        // this.code = 'select * from Albums';
        this.appComp.currentPageTitle = 'Generate API from SQL Query';
        this.enableEditor = true;

        const getAttributesForQueryBuilder = new Promise(async (resolve, reject) => {
            if (!this.cloneable) {
                if (this.platform.queryBuilderAttributes !== null && this.platform.queryBuilderAttributes !== undefined) {
                    this.databaseFlag = true;
                    this.dbItem = this.platform.queryBuilderAttributes;
                    this.dbs = this.dbItem.body[0];
                    // this.dbs.databases.forEach((dblist) => {
                    //   if (dblist.database_type.includes('sql')) {
                    //     this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                    //   }
                    // });
                    resolve('success');
                } else {
                    await this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                        this.databaseFlag = true;
                        this.dbItem = db;
                        this.platform.queryBuilderAttributes = db;
                        this.dbs = this.dbItem.body[0];
                        // this.dbs.databases.forEach((dblist) => {
                        //   if (dblist.database_type.includes('sql')) {
                        //     this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                        //   }
                        // });
                        resolve('success');
                    }, error => {
                        resolve('failed');
                        this.platform.handleErrorGracefully(error, 'Error while retrieving attributes for query builder. Please try again after sometime.');
                    });
                }
            } else {
                resolve('success');
            }
        });

        const getDatabases = new Promise(async (resolve, reject) => {
            if (this.platform.databases !== null && this.platform.databases !== undefined) {
                let response: any;
                let databases = [];
                await this.platform.updateIsNoSQLForMongo(this.platform.databases);
                response = this.platform.databases;
                if (response.hasOwnProperty('databaseDetails')) {
                    databases = response['databaseDetails'];
                } else {
                    databases = response;
                }
                databases.forEach((dblist) => {
                    if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
                        this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                    }
                });
                resolve('success');
            } else {
                // this.platform.getDatabasesForPartnerAccount();
                await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async data => {
                        let response: any;
                        let databases = [];
                        await this.platform.updateIsNoSQLForMongo(data);
                        response = this.platform.databases;
                        if (response.hasOwnProperty('databaseDetails')) {
                            databases = response['databaseDetails'];
                        } else {
                            databases = response;
                        }
                        databases.forEach((dblist) => {
                            if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
                                this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                            }
                        });
                        resolve('success');
                    },
                    error => {
                        resolve('failed');
                        this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                    });
            }
        });

        Promise.all([getAttributesForQueryBuilder, getDatabases]).then(resp => {
            this.componentLoading = false;
        });

    }

    getApiExecutorByPartnerAccountByNameAndVersion(partner, account, executorName, executorVersion) {
        return new Promise((resolve, reject) => {
            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(partner, account, executorName, executorVersion).subscribe(exec => {
                this.executor = exec;
                if (this.executor) {
                    this.orig_executor = exec;
                    this.executor_name = this.executor.executor_name;
                    this.selectedVersion = this.executor.executor_version;
                    this.selectedExecutorType = this.executor.executor_type;
                    this.selectedExecutor = this.executor.executor_method_type;
                    this.executorCategory = this.executor.executor_category;
                    this.executor_display_name = this.executor.executor_display_name;
                    this.description = this.executor.executor_description;
                    this.queryParams = this.executor.queryParams;
                    this.pathParams = this.executor.pathParams;
                    this.headers = this.executor.headers;
                    this.mockResponses = this.executor.mockResponses;
                    this.requestBody = this.executor.requestBody;
                    this.executorModel = this.executor.executors[0];
                    this.scopeSelected = this.executor.scopeOfAccess;
                    this.gatewaySettings = this.executor.gatewaySettings;
                    if (this.gatewaySettings) {
                        const gateways = [];
                        if (this.gatewaySettings) {
                            if (this.gatewaySettings.length > 0) {
                                for (const gateway of this.gatewaySettings) {
                                    gateways.push(gateway['name']);
                                }
                            }
                        }
                        if (gateways.length === 0) {
                            gateways.push('default');
                        }
                        this.gatewayControl.setValue(gateways); // To trigger change detection
                    }
                    if (this.executorModel) {
                        if (this.executorModel.database) {
                            if (this.executorModel.database.hasOwnProperty('databaseDetails')) {
                                this.database = this.executorModel.database.databaseDetails.database_name; //{'db_name': this.executorModel.database.database_name, 'db_type': this.executorModel.database.database_type};
                            } else {
                                this.database = this.executorModel.database.database_name;
                            }
                        }
                        if (this.executorModel.hasOwnProperty('query')) {
                            this.code = this.executorModel.query;
                        }
                    }
                    // this.databaseSelected = this.database.db_name;
                    if (this.executor.responseAttributes !== null) {
                        this.responseAttributes = this.executor.responseAttributes;
                    }
                }
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

    jsonstringify(val) {
        return JSON.stringify(val, null, 2).trim();
    }

    async getDatabases() {
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            let response: any;
            let databases = [];
            await this.platform.updateIsNoSQLForMongo(this.platform.databases);
            response = this.platform.databases;
            if (response.hasOwnProperty('databaseDetails')) {
                databases = response['databaseDetails'];
            } else {
                databases = response;
            }
            databases.forEach((dblist) => {
                if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
                    this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                }
            });
        } else {
            // this.platform.getDatabasesForPartnerAccount();
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async data => {
                    let response: any;
                    let databases = [];
                    await this.platform.updateIsNoSQLForMongo(data);
                    response = this.platform.databases;
                    if (response.hasOwnProperty('databaseDetails')) {
                        databases = response['databaseDetails'];
                    } else {
                        databases = response;
                    }
                    databases.forEach((dblist) => {
                        if (dblist && dblist.hasOwnProperty('is_nosql') && dblist['is_nosql'] === false) {
                            this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                        }
                    });
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
        }
    }

    getDatabaseList() {
        return new Promise(async (resolve, reject) => {
            if (this.platform.queryBuilderAttributes !== null && this.platform.queryBuilderAttributes !== undefined) {
                this.databaseFlag = true;
                this.dbItem = this.platform.queryBuilderAttributes;
                this.dbs = this.dbItem.body[0];
                // this.dbs.databases.forEach((dblist) => {
                //   if (dblist.database_type.includes('sql')) {
                //     this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                //   }
                // });
                this.getDatabases();
                resolve('success');
            } else {
                await this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                    this.databaseFlag = true;
                    this.dbItem = db;
                    this.platform.queryBuilderAttributes = db;
                    this.dbs = this.dbItem.body[0];
                    // this.dbs.databases.forEach((dblist) => {
                    //   if (dblist.database_type.includes('sql')) {
                    //     this.databaseList.push({'db_name': dblist.database_name, 'db_type': dblist.database_type});
                    //   }
                    // });
                    this.getDatabases();
                    resolve('success');
                }, error => {
                    resolve('failed');
                    this.platform.handleErrorGracefully(error, 'Error while retrieving attributes for query builder. Please try again after sometime.');
                });
            }
        });
    }

    async saveAPI() {

        let saveClickedMessage = '';
        let saveSuccessMessage = '';
        let saveFailureMessage = '';

        if (this.editFlag) {
            saveClickedMessage = 'sqlquery_edit_save_clicked';
            saveSuccessMessage = 'sqlquery_edit_save_success';
            saveFailureMessage = 'sqlquery_edit_save_success';
        } else {
            saveClickedMessage = 'sqlquery_create_save_clicked';
            saveSuccessMessage = 'sqlquery_create_save_success';
            saveFailureMessage = 'sqlquery_create_save_success';
        }

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, saveClickedMessage, 'INFO', 200, 'OK',
            '', '', '', this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.SQLQueryListenerInstance.sqlQueryListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        await this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.database).toPromise().then(db => {
            this.executorModel = {
                'database': {},
                'query': this.code !== null ? this.code.trim().replace(/\n/g, ' ') : null,
            };
            if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                this.executorModel.database['database_name'] = db['database_name'];
                this.executorModel.database['database_type'] = db['database_type'];
            }

            const savePayload = {
                partner: '',
                account: '',
                executor_name: '',
                executor_type: '',
                by: '',
                executor_version: '',
                action: ''
            };

            savePayload.partner = this.partner;
            savePayload.account = this.account_id;
            savePayload['at'] = Date.now();
            savePayload.by = this.partner;

            if (this.executorComp.executor_name !== null && this.executorComp.executor_name !== undefined && this.executorComp.executor_name !== '') {
                savePayload.executor_name = this.executorComp.executor_name;
            } else {
                savePayload.executor_name = Date.now().toString();
            }

            if (this.executorComp.selectedVersion && this.executorComp.selectedVersion !== undefined && this.executorComp.selectedVersion !== null && this.executorComp.selectedVersion !== '') {
                savePayload.executor_version = this.executorComp.selectedVersion;
            } else {
                savePayload.executor_version = 'No Ver.';
            }
            if (this.editFlag) {
                savePayload.action = 'UPDATE';
            } else {
                savePayload.action = 'CREATE';
            }
            savePayload.executor_type = 'SQLQUERY';

            const requestBodyResponse = this.executorComp.getRequestBody();
            let requestBody = {};
            if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
                requestBody = requestBodyResponse['__zone_symbol__value'];
            } else {
                requestBody = requestBodyResponse;
            }


            const executorModel = {
                'executor_type': this.executorComp.selectedExecutorType,
                'executor_name': this.executorComp.executor_name,
                'executor_version': this.executorComp.selectedVersion,
                'executor_display_name': this.executorComp.executor_display_name,
                'executor_description': this.executorComp.description,
                'executor_category': this.executorComp.executorCategory,
                'executor_method_type': this.executorComp.selectedExecutor,
                'published': true,
                'scopeOfAccess': this.executorComp.scopeSelected,
                'creationTime': Date.now(),
                'lastModifiedTime': Date.now(),
                'registeredAsIs': false,
                'queryParams': this.executorComp.queryParams,
                'headers': this.executorComp.headers,
                'mockResponses': this.executorComp.mockResponses,
                'authModel': this.executorComp.authModel,
                'requestBody': requestBody,
                'source': this.code.trim(),
                'executors': [this.executorModel],
                'partner': this.partner,
                'account_id': this.account_id,
                'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
                'dataroot': null,
                'responseAttributes': this.executorComp.responseAttributes,
                'attributeMappings': null,
                'response': null,
                'block_attributes': null
            };

            // savePayload['executor'] = this.getAPIExecutorModelForSQLQuery(this.executorModel);
            savePayload['executor'] = executorModel;
            const temp = JSON.parse(JSON.stringify(savePayload['executor']));
            let isSame = true;
            if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
                if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                    const keyArray = Object.keys(this.previousSavedData);
                    for (const key of keyArray) {
                        if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                            continue;
                        } else {
                            isSame = false;
                            break;
                        }
                    }
                } else {
                    isSame = false;
                }
            } else {
                isSame = false;
            }

            if (isSame === false) {
                this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, saveSuccessMessage, 'INFO', data.status, data.statusText,
                        '', executorModel, data, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.SQLQueryListenerInstance.sqlQueryListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    const log_payload = {
                        logType: 'INFO',
                        logLevel: 0,
                        slugSearch: '',
                        label: 'API_SAVE',
                        featureArea: this.platform.auditFeatureArea.queryBuilder,
                        resource: 'API_SAVE',
                        action: 'SAVE',
                        result: 'SUCCESS',
                        payload: executorModel,
                        responseStatusCode: data.status,
                        response: data,
                        errorMessage: '',
                        logMessage: 'API saved'
                    };
                    this.auditLog.log(log_payload);
                    this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                    this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
                }, error => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, saveFailureMessage, 'ERROR',
                        error.status, error.statusText, this.platform.returnErrorMessage(error), executorModel, error, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.SQLQueryListenerInstance.sqlQueryListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    const log_payload = {
                        logType: 'ERROR',
                        logLevel: 0,
                        slugSearch: '',
                        label: 'API_SAVE',
                        featureArea: this.platform.auditFeatureArea.queryBuilder,
                        resource: 'API_SAVE',
                        action: 'SAVE',
                        result: 'FAIL',
                        payload: executorModel,
                        responseStatusCode: error.status,
                        response: error,
                        errorMessage: this.platform.returnErrorMessage(error),
                        logMessage: 'API saved'
                    };
                    this.auditLog.log(log_payload);
                    this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            } else {
                this.platform.openSnackBar('No changes to save for this API.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            this.platform.openSnackBar('Please select a valid Database.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.router.navigateByUrl('/querybuilder');
        });
    }

    getAPIExecutorModelForSQLQuery(SQLExecutorModel: any) {

        const requestBodyResponse = this.executorComp.getRequestBody();
        let requestBody = {};
        if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
            requestBody = requestBodyResponse['__zone_symbol__value'];
        } else {
            requestBody = requestBodyResponse;
        }

        const gateways = this.executorComp.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }


        const executorModel = {
            'executor_type': this.executorComp.selectedExecutorType,
            'executor_name': this.executorComp.executor_name,
            'executor_version': this.executorComp.selectedVersion,
            'executor_display_name': this.executorComp.executor_display_name,
            'executor_description': this.executorComp.description,
            'executor_category': this.executorComp.executorCategory,
            'executor_method_type': this.executorComp.selectedExecutor,
            'published': true,
            'scopeOfAccess': this.executorComp.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'queryParams': this.executorComp.queryParams,
            'headers': this.executorComp.headers,
            'mockResponses': this.executorComp.mockResponses,
            'authModel': this.executorComp.authModel,
            'requestBody': requestBody,
            'prerequisites': this.executorComp.prerequisites,
            'source': this.code.trim(),
            'executors': [SQLExecutorModel],
            'partner': this.partner,
            'account_id': this.account_id,
            'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
            'dataroot': null,
            // 'responseAttributes': this.executorComp.responseAttributes,
            'attributeMappings': null,
            'response': null,
            'block_attributes': null,
            'gatewaySettings': gatewaySettings
        };
        return executorModel;
    }


    getQueryCondition() {
        const constructQueryPayLoad = {
            'database_name': this.database['db_name'],
            'database_type': this.database['db_type'],
            'input_format': 'JSON',
            'table_list': this.tableSelected,
            'projections': this.getProjectionData(this.attribute),
            'collections': [this.getCollectionsData(this.tableSelected)],
            'conditions': [this.queryRuleset],
            'sort_by': [],
            'result_format': ['JSON'],
            'group_by': []
        };
        return constructQueryPayLoad;
    }


    getAPIExecutorModelForQuery() {

        const requestBodyResponse = this.executorComp.getRequestBody();
        let requestBody = {};
        if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
            requestBody = requestBodyResponse['__zone_symbol__value'];
        } else {
            requestBody = requestBodyResponse;
        }

        const executorModel = {
            'executor_type': this.executorComp.selectedExecutorType,
            'executor_name': this.executorComp.executor_name,
            'executor_version': this.executorComp.selectedVersion,
            'executor_display_name': this.executorComp.executor_display_name,
            'executor_description': this.executorComp.description,
            'executor_category': this.executorComp.executorCategory,
            'executor_method_type': this.executorComp.selectedExecutor,
            'published': true,
            'scopeOfAccess': this.executorComp.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'queryParams': this.executorComp.queryParams,
            'headers': this.executorComp.headers,
            'mockResponses': this.executorComp.mockResponses,
            'authModel': this.executorComp.authModel,
            'requestBody': requestBody,
            'prerequisites': this.executorComp.prerequisites,
            'source': JSON.stringify(this.queryRuleset),
            'executors': [this.getQueryCondition()],
            'partner': this.partner,
            'account_id': this.account_id,
            'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
            'dataroot': null,
            'responseAttributes': this.executorComp.responseAttributes,
            'attributeMappings': null,
            'response': null,
            'block_attributes': null
        };
        return executorModel;
    }

    async createOrUpdateApi() {
        this.editFlag = true;
        // var isSqlPresent = false;
        // if (this.code !== null && this.code !== undefined && this.code.length > 0) {
        //   isSqlPresent = true;
        // } else {
        //   if (confirm('Are you sure you want to deploy this API without any SQL Statement ?')) {
        //     isSqlPresent = true;
        //   }
        // }
        // if (isSqlPresent) {
        if (this.origEntity === this.executorComp.executor_name && this.origVersion === this.executorComp.selectedVersion) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.getAPIUsagesWithTestsuites(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                this.dependencyApis = response;
                loaderDialog.close();
                let totalTestcases = 0;
                let totalTestSuites = 0;
                for (const executor of  this.dependencyApis) {
                    totalTestcases += executor['no_of_testcases'] ? executor['no_of_testcases'] : 0;
                    totalTestSuites += executor['no_of_testsuites'] ? executor['no_of_testsuites'] : 0;
                }
                if (totalTestcases === 0 && totalTestSuites === 0 ) {
                    this.createApiForSqlQuery();
                } else {
                    const dialogRef = this.dialog.open(DependencyCheckComponent, {
                        width: '60%',
                        height: 'auto',
                        maxHeight: '70vh',
                        data: {
                            executors: this.dependencyApis,
                            executor_name: this.executor_name,
                            executor_version: this.selectedVersion
                        }
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        if (result && result.continue) {
                            this.createApiForSqlQuery(result.mode);
                        }
                    });
                }

            }, error => {
                loaderDialog.close();
                this.platform.openSnackBar('Error while fetching the usages of the API. Please try again later.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            const publishdata = {};
            var message = 'Change in entity';
            publishdata['origEntity'] = this.origEntity;
            publishdata['origVersion'] = this.origVersion;
            publishdata['entity'] = this.executorComp.executor_name;
            publishdata['version'] = this.executorComp.selectedVersion;
            publishdata['tableName'] = 'sqlquery';
            publishdata['origCollection'] = 'sqlquery';

            if (this.origEntity !== this.executorComp.executor_name) {
                if (this.origVersion !== this.executorComp.selectedVersion) {
                    message = 'Both the name and version of the SQL Query API have been changed. Hence this will create another SQL Query API : ' + this.executorComp.executor_name + ' with the version: ' + this.executorComp.selectedVersion + '. Do you want to continue creating a new SQL Query API ?';
                } else {
                    message = 'Name of the SQL Query API has been changed. Hence this will create another SQL Query API : ' + this.executorComp.executor_name + ' with the version: ' + this.executorComp.selectedVersion + '. Do you want to continue creating a new SQL Query API ?';
                }
            } else {
                if (this.origVersion !== this.executorComp.selectedVersion) {
                    message = 'Version of the SQL Query API has been changed. Hence this will create another SQL Query API : ' + this.executorComp.executor_name + ' with the version: ' + this.executorComp.selectedVersion + '. Do you want to continue creating a new SQL Query API ?';
                }
            }
            publishdata['message'] = message;
            let entityLength = 0;
            let versionLength = 0;
            for (let i = 0; i < this.executorComp.executor_name.length; i++) {
                if (this.executorComp.executor_name.charCodeAt(i) === 8 || this.executorComp.executor_name.charCodeAt(i) === 32 || (this.executorComp.executor_name.charCodeAt(i) > 64 && this.executorComp.executor_name.charCodeAt(i) < 91) || (this.executorComp.executor_name.charCodeAt(i) > 96 && this.executorComp.executor_name.charCodeAt(i) < 123) || (this.executorComp.executor_name.charCodeAt(i) >= 48 && this.executorComp.executor_name.charCodeAt(i) <= 57)) {
                    entityLength++;
                }
            }

            for (let i = 0; i < this.executorComp.selectedVersion.length; i++) {
                if (this.executorComp.selectedVersion.charCodeAt(i) === 8 || this.executorComp.selectedVersion.charCodeAt(i) === 32 || (this.executorComp.selectedVersion.charCodeAt(i) > 64 && this.executorComp.selectedVersion.charCodeAt(i) < 91) || (this.executorComp.selectedVersion.charCodeAt(i) > 96 && this.executorComp.selectedVersion.charCodeAt(i) < 123) || (this.executorComp.selectedVersion.charCodeAt(i) >= 48 && this.executorComp.selectedVersion.charCodeAt(i) <= 57)) {
                    versionLength++;
                }
            }
            if (entityLength > 0 && versionLength > 0) {
                if (versionLength === this.executorComp.selectedVersion.length && entityLength === this.executorComp.executor_name.length) {
                    if (this.executorComp.isAPIAlreadyPresentCheckCompleted === false) {
                        await this.executorComp.checkForExistingEntityAndExecutor();
                    }

                    if (this.executorComp.isAPIAlreadyPresent === false) {
                        const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                            width: '60%',
                            data: publishdata
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result) {
                                // Create API
                                this.redeployNewExecutor = true;
                                this.createApiForSqlQuery();
                                // if (dialogRef.componentInstance.copyData) {
                                // } else {
                                // }
                            } else {
                                this.loading = false;
                            }
                        });
                    } else {
                        this.loading = false;
                        this.platform.openSnackBar('An API with the provided name and version already exists..', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                    this.platform.openSnackBar('Special characters are not allowed in version and entity.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
            }
        }


        // } else {
        //   this.loading = false;
        // }
    }

    checkForExistingExecutorAndVersion() {
        if ((this.partnerEntities.filter(element => (element.entityname === this.executorComp.executor_name && element.version === this.executorComp.selectedVersion)).length === 0)) {
            if ((this.partnerExecutors.filter(element => (element.executor_name === this.executorComp.executor_name && element.executor_version === this.executorComp.selectedVersion)).length === 0)) {
                this.isAPIAlreadyPresent = false;
            } else {
                this.isAPIAlreadyPresent = true;
            }
        } else {
            this.isAPIAlreadyPresent = true;
        }
    }

    setHeaders() {
        if (this.executorModelPayload.headers) {
            for (let i = 0; i < this.executorModelPayload.headers.length; i++) {
                if (this.executorModelPayload.headers[i]) {
                    if (this.executorModelPayload.headers[i]['key'] === '') {
                        this.executorModelPayload.headers.splice(i, 1);
                    }
                }
            }
        }
        if (this.executorModelPayload.headers.filter(element => element.key === 'pkey').length === 0) {
            this.executorModelPayload.headers.push({
                key: 'pkey',
                value: localStorage.getItem('partnerKey'),
                description: ''
            });
        }
        if (this.executorModelPayload.headers.filter(element => element.key === 'apikey').length === 0) {
            this.executorModelPayload.headers.push({
                key: 'apikey',
                value: localStorage.getItem('apikey'),
                description: ''
            });
        }
    }

    async createAPI(timeStamp, testMode = 'notests') {
        let action = '';
        if (this.editFlag === true) {
            action = 'redeploy';
        } else {
            action = 'deploy';
        }

        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
            info: 'Checking for special characters in Executor name',
            type: 'initial',
            icon: 'fa fa-newspaper-o'
        }, timeStamp, action);
        Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.executorComp.executor_name)).then(async resp1 => {
            if (resp1 === true) {
                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                    info: 'Checking for special characters in Executor name',
                    type: 'success',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, action);
                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                    info: 'Checking for special characters in Executor version',
                    type: 'initial',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, action);
                Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.executorComp.selectedVersion)).then(async resp2 => {
                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for special characters in Executor version',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, action);

                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for API existence',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for API existence',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    if (resp2 === true) {
                        // var isSqlPresent = false;
                        // if (this.code !== null && this.code !== undefined && this.code.length > 0) {
                        //   isSqlPresent = true;
                        // } else {
                        //   if (confirm('Are you sure you want to deploy this API without any SQL Statement ?')) {
                        //     isSqlPresent = true;
                        //   }
                        // }
                        if (this.isSqlPresent) {
                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DESIGN', {
                                info: 'Checking for all required fields',
                                type: 'initial',
                                icon: 'fa fa-file-code-o'
                            }, timeStamp, action);
                            if (!this.database ||
                                (this.executorComp && !this.executorComp.executor_name)
                                || (this.executorComp && !this.executorComp.selectedVersion)
                                || (this.executorComp && !this.executorComp.selectedExecutor)
                                || (this.executorComp && !this.executorComp.executorCategory)) {

                                Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                                    this.auditListenerService.auditListener.emit({
                                        type: 'auditLog',
                                        category: 'isAuditForSQLQuery',
                                        payload: response
                                    });
                                });
                                this.loading = false;
                                this.closeNonWSDialogBox();

                                // this.displaySnackBarWithWS('Error', 5000, 'Please check if you have entered value for required fields: API Name, Version, Method Type, Category and Database.');
                                await this.platform.delay(1500);
                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DESIGN', {
                                    info: 'Checking for all required fields',
                                    icon: 'fa fa-file-code-o',
                                    type: 'fatal'
                                }, timeStamp, action);
                                // this.platform.openSnackBar('Please check if you have entered value for required fields: API Name, Version, Method Type, Category and Database.', 'Error', {
                                //   duration: 10000,
                                //   verticalPosition: 'top',
                                //   horizontalPosition: 'center'
                                // });
                            } else {
                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DESIGN', {
                                    info: 'Checking for all required fields',
                                    type: 'success',
                                    icon: 'fa fa-file-code-o'
                                }, timeStamp, action);

                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                    info: 'Generating the API',
                                    icon: 'fa fa-code',
                                    type: 'initial'
                                }, timeStamp, action);
                                let entityLength = 0;
                                let versionLength = 0;

                                for (let i = 0; i < this.executorComp.executor_name.length; i++) {
                                    if (this.executorComp.executor_name.charCodeAt(i) === 8 || this.executorComp.executor_name.charCodeAt(i) === 32 || (this.executorComp.executor_name.charCodeAt(i) > 64 && this.executorComp.executor_name.charCodeAt(i) < 91) || (this.executorComp.executor_name.charCodeAt(i) > 96 && this.executorComp.executor_name.charCodeAt(i) < 123) || (this.executorComp.executor_name.charCodeAt(i) >= 48 && this.executorComp.executor_name.charCodeAt(i) <= 57)) {
                                        entityLength++;
                                    }
                                }

                                for (let i = 0; i < this.executorComp.selectedVersion.length; i++) {
                                    if (this.executorComp.selectedVersion.charCodeAt(i) === 8 || this.executorComp.selectedVersion.charCodeAt(i) === 32 || (this.executorComp.selectedVersion.charCodeAt(i) > 64 && this.executorComp.selectedVersion.charCodeAt(i) < 91) || (this.executorComp.selectedVersion.charCodeAt(i) > 96 && this.executorComp.selectedVersion.charCodeAt(i) < 123) || (this.executorComp.selectedVersion.charCodeAt(i) >= 48 && this.executorComp.selectedVersion.charCodeAt(i) <= 57)) {
                                        versionLength++;
                                    }
                                }

                                // if (this.editFlag) {
                                //     if (this.orig_executor_name !== this.executorComp.executor_name || this.orig_executor_version !== this.executorComp.selectedVersion) {
                                //         this.checkForExistingExecutorAndVersion();
                                //     } else {
                                //         this.isAPIAlreadyPresent = false;
                                //     }
                                // } else {
                                //     this.checkForExistingExecutorAndVersion();
                                // }

                                // if (!this.isAPIAlreadyPresent) {
                                if (entityLength === this.executorComp.executor_name.length) {
                                    if (versionLength === this.executorComp.selectedVersion.length) {
                                        if (this.editFlag) {
                                            this.eventNameForAudit = 'sqlquery_edit_redeploy_clicked';
                                        } else {
                                            this.eventNameForAudit = 'sqlquery_create_deploy_clicked';
                                        }
                                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, this.eventNameForAudit, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
                                            const payloadToSend = {
                                                actions: response1
                                            };
                                            this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                type: 'audit',
                                                id: localStorage.getItem('IdOfSession'),
                                                payload: payloadToSend
                                            });
                                        });
                                        this.loading = true;
                                        if (this.editFlag) {
                                            this.eventNameForAudit = 'sqlquery_edit_redeploy_success';
                                        } else {
                                            this.eventNameForAudit = 'sqlquery_create_deploy_success';
                                        }
                                        if (this.executorComp.selectedExecutorType.toString() === 'SQLQUERY') {
                                            this.executorModelPayload = this.getAPIExecutorModelForSQLQuery(this.executorModel);
                                            this.databaseName = this.database;

                                        } else if (this.executorComp.selectedExecutorType.toString() === 'QUERY') {
                                            this.executorModelPayload = this.getAPIExecutorModelForQuery();
                                            this.databaseName = this.database['db_name'];

                                        }

                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                            info: 'Connecting to the database',
                                            type: 'initial',
                                            icon: 'fa fa-code'
                                        }, timeStamp, action);
                                        await this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.databaseName).subscribe(db => {
                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                                info: 'Connecting to the database',
                                                type: 'success'
                                            }, timeStamp, action);
                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                                info: 'Generating the API',
                                                icon: 'fa fa-code',
                                                type: 'success'
                                            }, timeStamp, action);

                                            this.executorModelPayload.executors = [];
                                            if (this.executorComp.selectedExecutorType.toString() === 'SQLQUERY') {
                                                this.executorModel = {
                                                    'database': {},
                                                    'query': this.code.trim().replace(/\n/g, ' '),
                                                    'paramPrefixSubString': ' :'
                                                };
                                                if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                                                    this.executorModel.database['database_name'] = db['database_name'];
                                                    this.executorModel.database['database_type'] = db['database_type'];
                                                }
                                            }
                                            this.executorModelPayload.executors.push(this.executorModel);

                                            var that = this;
                                            // this.requestBody = this.executorComp.requestBody;
                                            if (action === 'redeploy' && !this.redeployNewExecutor) {
                                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                    info: 'Capturing changes made in API definition',
                                                    type: 'initial',
                                                    icon: 'fa fa-cloud-upload'
                                                }, timeStamp, action);
                                            }
                                            // else {
                                            //   this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                            //     info: 'Setting up API',
                                            //     type: 'initial',
                                            //     icon : 'fa fa-cloud-upload'}, timeStamp, action);
                                            // }
                                            this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(async exec => {
                                                this.executor = exec;
                                                if (this.executor) {


                                                    if (this.executorComp.selectedExecutorType.toString() === 'SQLQUERY' &&
                                                        this.executor['source'] === this.code.trim() &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_display_name'], this.orig_executor['executor_display_name']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_description'], this.orig_executor['executor_description']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_category'], this.orig_executor['executor_category']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_category_group'], this.orig_executor['executor_category_group']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['service_provider'], this.orig_executor['service_provider']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['scopeOfAccess'], this.orig_executor['scopeOfAccess']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['executor_method_type'], this.orig_executor['executor_method_type']) &&
                                                        this.platform.checkEqualStrings(this.executorModelPayload['dataroot'], this.orig_executor['dataroot']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['prerequisites'], this.orig_executor['prerequisites']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['responseAttributes'], this.orig_executor['responseAttributes']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['response'], this.orig_executor['response']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['attributeMappings'], this.orig_executor['attributeMappings']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['block_attributes'], this.orig_executor['block_attributes']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['workflow_credentials'], this.orig_executor['workflow_credentials']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['pathParams'], this.orig_executor['pathParams']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['queryParams'], this.orig_executor['queryParams']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['headers'], this.orig_executor['headers']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['mockResponses'], this.orig_executor['mockResponses']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['authModel'], this.orig_executor['authModel']) &&
                                                        this.platform.checkEquality(this.executorModelPayload['requestBody'], this.orig_executor['requestBody'])) {
                                                        this.loading = false;
                                                        this.closeNonWSDialogBox();

                                                        if (action === 'redeploy' && !this.redeployNewExecutor) {
                                                            // this.displaySnackBarWithWS('Error', 5000, 'No changes to save for this SQL Query API.');
                                                            this.loading = false;
                                                            await this.platform.delay(500);
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                                info: 'Capturing changes made in API definition',
                                                                type: 'fatal',
                                                                description: 'No changes to save for this SQL Query API.',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);
                                                            this.closeNonWSDialogBox();

                                                            this.redeployNewExecutor = false;

                                                        }
                                                        // else {
                                                        //   this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                                        //     info: 'Setting up API',
                                                        //     type: 'fatal',
                                                        //     icon : 'fa fa-cloud-upload'}, timeStamp, action);
                                                        // }

                                                        // this.platform.openSnackBar('No changes to save for this SQL Query API.', 'Error', {
                                                        //   duration: 10000,
                                                        //   verticalPosition: 'top',
                                                        //   horizontalPosition: 'center'
                                                        // });
                                                    } else {

                                                        if (action === 'redeploy' && !this.redeployNewExecutor) {
                                                            this.redeployNewExecutor = false;
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                                info: 'Capturing changes made in API definition',
                                                                type: 'success',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);
                                                        }
                                                        // else {
                                                        //   this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                                        //     info: 'Setting up API',
                                                        //     type: 'success',
                                                        //     icon : 'fa fa-cloud-upload'}, timeStamp, action);
                                                        // }
                                                        this.executorModelPayload['creationTime'] = exec['creationTime'];
                                                        this.setHeaders();
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                            info: 'Updating API Executor',
                                                            type: 'initial',
                                                            icon: 'fa fa-cloud-upload'
                                                        }, timeStamp, action);
                                                        this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account_id, exec['id'], this.executorModelPayload).subscribe(async data => {
                                                            this.save = true;
                                                            this.platform.updateAPIAuditLog(this.partner, this.account_id, this.executorModelPayload['executor_name'], this.executorModelPayload['executor_version'], 'SQLQUERY', this.executorModelPayload, exec);

                                                            this.executor_name = this.executorModelPayload.executor_name;
                                                            this.selectedVersion = this.executorModelPayload.executor_version;
                                                            this.selectedExecutor = this.executorModelPayload.executor_method_type;
                                                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, this.eventNameForAudit, 'INFO', data.status, data.statusText, '', this.executorModelPayload, data, this.router.url)).then(response => {
                                                                const payloadToSend = {
                                                                    actions: response
                                                                };
                                                                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                                    type: 'audit',
                                                                    id: localStorage.getItem('IdOfSession'),
                                                                    payload: payloadToSend
                                                                });
                                                            });
                                                            this.Blocks = [1, 2, 4];
                                                            const blockLength = this.Blocks.length;
                                                            const blockStart = this.BlockList[this.Blocks[0]];
                                                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                                            this.progress = blockStart;
                                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');


                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                                                info: 'Updating Gateway Settings for the API',
                                                                type: 'initial',
                                                                icon: 'fa fa-shield'
                                                            }, timeStamp, action);
                                                            await this.kongService.updateRouteWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, [this.selectedExecutor], timeStamp, action);
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                                                info: 'Updating Gateway Settings for the API',
                                                                type: 'success',
                                                                icon: 'fa fa-shield'
                                                            }, timeStamp, action);
                                                            // this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion, false, true, [this.executorComp.selectedExecutorType]);
                                                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                                            this.save = false;
                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REDEPLOYMENT', {
                                                                info: 'Updating API Executor',
                                                                type: 'success',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);


                                                            if (testMode === 'alltests') {
                                                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                    info: 'Executing test-suites for API usages',
                                                                    icon: 'fa fa-check-square-o',
                                                                    type: 'initial',
                                                                    messageType: 'test-results'
                                                                }, timeStamp, action);
                                                                this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(async response => {
                                                                    let suiteResponse: any;
                                                                    suiteResponse = response;

                                                                    if (suiteResponse.testsPassRate === 100) {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'success',
                                                                            messageType: 'test-results',
                                                                            description: 'Test Suite pass rate: 100%',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    } else {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'warning',
                                                                            description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                                            messageType: 'test-results',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.revertExecutorChanges(this.executor, this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    }
                                                                }, async error => {
                                                                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                        info: 'Executing test-suites for API usages',
                                                                        icon: 'fa fa-check-square-o',
                                                                        type: 'error',
                                                                        messageType: 'test-results',
                                                                        description: 'Testsuite execution failed. Please try again.'
                                                                    }, timeStamp, action);
                                                                    await this.revertExecutorChanges(this.executor, this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);

                                                                });

                                                            } else if (testMode === 'force') {
                                                                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                    info: 'Executing test-suites for API usages',
                                                                    icon: 'fa fa-check-square-o',
                                                                    type: 'initial'
                                                                }, timeStamp, action);
                                                                this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(async response => {
                                                                    let suiteResponse: any;
                                                                    suiteResponse = response;

                                                                    if (suiteResponse.testsPassRate === 100) {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'success',
                                                                            messageType: 'test-results',
                                                                            description: 'Test Suite pass rate: 100%',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    } else {
                                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                            info: 'Executing test-suites for API usages',
                                                                            icon: 'fa fa-check-square-o',
                                                                            type: 'warning-low',
                                                                            description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                                            messageType: 'test-results',
                                                                            data: {testResultId: suiteResponse['resultsId']}
                                                                        }, timeStamp, action);
                                                                        await this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                    }

                                                                }, error => {
                                                                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                                        info: 'Executing test-suites for API usages',
                                                                        icon: 'fa fa-check-square-o',
                                                                        type: 'error',
                                                                        description: 'Testsuite execution failed. Please try again.'
                                                                    }, timeStamp, action);
                                                                    this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                                });
                                                            } else {
                                                                this.finishAPIDeployment(this.executorComp.executor_name, this.executorComp.selectedVersion, action, timeStamp);
                                                            }

                                                            // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DOCUMENTATION', {
                                                            //     info: 'Regenerating Documentation',
                                                            //     type: 'initial',
                                                            //     icon: 'fa fa-book'
                                                            // }, timeStamp, action);
                                                            // await this.platform.delay(1000);
                                                            // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DOCUMENTATION', {
                                                            //     info: 'Regenerating Documentation',
                                                            //     type: 'success',
                                                            //     icon: 'fa fa-book'
                                                            // }, timeStamp, action);


                                                            // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API TESTING', {
                                                            //     info: 'Checking for testcases <br>Testcases found: 0',
                                                            //     icon: 'fa fa-check-square-o',
                                                            //     type: 'initial'
                                                            // }, timeStamp, action);
                                                            // await this.platform.delay(1000);
                                                            // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API TESTING', {
                                                            //     info: 'Checking for testcases <br>Testcases found: 0',
                                                            //     icon: 'fa fa-check-square-o',
                                                            //     type: 'success'
                                                            // }, timeStamp, action);
                                                            // await this.platform.delay(2000);
                                                            // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'DONE', {
                                                            //     info: '',
                                                            //     type: 'success',
                                                            //     icon: 'fa fa-check'
                                                            // }, timeStamp, action);
                                                            // if(!this.connection){
                                                            //   this.platform.openSnackBar('API Deployed Successfully', 'Success', {
                                                            //     duration: 10000,
                                                            //     verticalPosition: 'top',
                                                            //     horizontalPosition: 'center'
                                                            //   });
                                                            // }
                                                            Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'SUCCESS', '', data.status, data, data.statusText, '')).then(response => {
                                                                this.auditListenerService.auditListener.emit({
                                                                    type: 'auditLog',
                                                                    category: 'isAuditForSQLQuery',
                                                                    payload: response
                                                                });
                                                            });

                                                        }, error => {

                                                            Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', this.executorModelPayload, error.status, '', '', error.statusText)).then(response => {
                                                                this.auditListenerService.auditListener.emit({
                                                                    type: 'auditLog',
                                                                    category: 'isAuditForSQLQuery',
                                                                    payload: response
                                                                });
                                                            });

                                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEPLOYMENT', {
                                                                info: 'Updating API Executor',
                                                                type: 'error',
                                                                icon: 'fa fa-cloud-upload'
                                                            }, timeStamp, action);
                                                            if (this.editFlag) {
                                                                this.eventNameForAudit = 'sqlquery_edit_redeploy_failed';
                                                            } else {
                                                                this.eventNameForAudit = 'sqlquery_create_deploy_failed';
                                                            }
                                                            this.loading = false;
                                                            this.closeNonWSDialogBox();

                                                            // this.displaySnackBarWithWS('Error', 5000, 'There is an error while deploying SQL Query API onto Cloud... Please report this to Technical Support team');

                                                            // this.platform.openSnackBar('There is an error while deploying SQL Query API onto Cloud... Please report this to Technical Support team', 'Error', {
                                                            //   duration: 10000,
                                                            //   verticalPosition: 'top',
                                                            //   horizontalPosition: 'center'
                                                            // });
                                                            let errorMessage = '';
                                                            if (error.error['message']) {
                                                                errorMessage = error.error.message;
                                                            } else {
                                                                let title = '';
                                                                if (this.editFlag) {
                                                                    title = 'Error while updating';
                                                                } else {
                                                                    title = 'Error while creating';
                                                                }
                                                                // this.displaySnackBarWithWS('Error', 5000, error.error);
                                                                this.loading = false;
                                                                this.closeNonWSDialogBox();

                                                                // this.platform.openSnackBar(error.error, 'Error', {
                                                                //   duration: 10000,
                                                                //   verticalPosition: 'top',
                                                                //   horizontalPosition: 'center'
                                                                // });
                                                                errorMessage = error.error;
                                                            }
                                                            Promise.resolve(this.platform.generateActionPayloadForAudit(true, this.eventNameForAudit, 'ERROR', error.status, error.statusText, errorMessage, this.executorModelPayload, error, this.router.url)).then(response => {
                                                                const payloadToSend = {
                                                                    actions: response
                                                                };
                                                                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                                    type: 'audit',
                                                                    id: localStorage.getItem('IdOfSession'),
                                                                    payload: payloadToSend
                                                                });
                                                            });
                                                            this.save = false;
                                                        });

                                                        // this.confPost.deleteApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.partnerKey, this.executorComp.executor_name, this.executorComp.selectedVersion).subscribe(deleted => {
                                                        //   if (deleted) {
                                                        //     this.setHeaders();
                                                        //     this.confPost.insertApiExecutorForPartnerAccount(this.partner, this.account_id, this.executorModelPayload).subscribe(data => {
                                                        //
                                                        //     });
                                                        //   }
                                                        // });
                                                    }
                                                } else {
                                                    // this.kongService.configureApiGatewayWithIpRestriction(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion, false, true);
                                                    this.setHeaders();

                                                    // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                                    //   info: 'Deploying API',
                                                    //   type: 'initial',
                                                    //   icon : 'fa fa-cloud-upload'}, timeStamp, action);
                                                    this.confPost.insertApiExecutorForPartnerAccount(this.partner, this.account_id, this.executorModelPayload).subscribe(async data => {
                                                        this.save = true;
                                                        this.platform.createAPIAuditLog(this.partner, this.account_id, this.executorModelPayload['executor_name'], this.executorModelPayload['executor_version'], 'SQLQUERY', this.executorModelPayload);
                                                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, this.eventNameForAudit, 'INFO', data.status, data.statusText, '', this.executorModelPayload, data, this.router.url)).then(response => {
                                                            const payloadToSend = {
                                                                actions: response
                                                            };
                                                            this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                                type: 'audit',
                                                                id: localStorage.getItem('IdOfSession'),
                                                                payload: payloadToSend
                                                            });
                                                        });

                                                        // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                                        //   info: 'Setting up API',
                                                        //   type: 'success',
                                                        //   icon : 'fa fa-cloud-upload'}, timeStamp, action);

                                                        this.executor_name = this.executorModelPayload.executor_name;
                                                        this.selectedVersion = this.executorModelPayload.executor_version;
                                                        this.selectedExecutor = this.executorModelPayload.executor_method_type;


                                                        // this.kongService.configureApiGatewayWithIpRestriction(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion, false, true);
                                                        // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'DEPLOYING API', {info:'Done',status:false, icon: 'fa fa-cogs'}, timeStamp, this.action);
                                                        // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API GATEWAY MANAGEMENT', {
                                                        //   info:'Configuring Gateway Settings for the API',
                                                        //   type:'initial',
                                                        //   icon: 'fa fa-shield'}, timeStamp, action);
                                                        await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.partner, this.account_id, this.executorComp.executor_name, this.executorComp.selectedVersion, false, true, [this.executorComp.selectedExecutor], timeStamp, action);
                                                        // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API GATEWAY MANAGEMENT', {
                                                        //   info:'Configuring Gateway Settings for the API',
                                                        //   type:'success',
                                                        //   icon: 'fa fa-shield'}, timeStamp, action);
                                                        // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                                        //   info: 'Deploying API',
                                                        //   type: 'success',
                                                        //   icon : 'fa fa-cloud-upload'}, timeStamp, action);
                                                        await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), this.executor_name, this.selectedVersion, 'SQLQUERY', true, timeStamp, action);

                                                        // this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion,'API DEPLOYMENT', {
                                                        //   info:'Deploying API',
                                                        //   type:'success',
                                                        //   icon: 'fa fa-cloud-upload'}, timeStamp, action);
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API TESTING', {
                                                            info: 'Checking for testcases <br>Testcases found: 0',
                                                            icon: 'fa fa-check-square-o',
                                                            type: 'initial'
                                                        }, timeStamp, action);
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API TESTING', {
                                                            info: 'Checking for testcases <br>Testcases found: 0',
                                                            icon: 'fa fa-check-square-o',
                                                            type: 'success'
                                                        }, timeStamp, action);
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DOCUMENTATION', {
                                                            info: 'Generating Documentation for the executor',
                                                            type: 'initial',
                                                            icon: 'fa fa-book'
                                                        }, timeStamp, action);
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DOCUMENTATION', {
                                                            info: 'Generating Documentation for the executor',
                                                            type: 'success',
                                                            icon: 'fa fa-book'
                                                        }, timeStamp, action);

                                                        await this.platform.delay(1500);
                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'DONE', {
                                                            info: '',
                                                            type: 'success',
                                                            icon: 'fa fa-check'
                                                        }, timeStamp, action);

                                                        Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'SUCCESS', '', data.status, data, data.statusText, '')).then(response => {
                                                            this.auditListenerService.auditListener.emit({
                                                                type: 'auditLog',
                                                                category: 'isAuditForSQLQuery',
                                                                payload: response
                                                            });
                                                        });

                                                        this.loading = false;
                                                        this.closeNonWSDialogBox();
                                                        this.Blocks = [1, 2, 4, 5];
                                                        const blockLength = this.Blocks.length;
                                                        const blockStart = this.BlockList[this.Blocks[0]];
                                                        const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                                        this.progress = blockStart;
                                                        this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');
                                                        this.leftPanelDataListener.notifyWorkflowBuilder.emit(this.executorComp.executor_name + '_' + this.executorComp.selectedVersion);
                                                        // if (!this.websocketService.isOpen()) {
                                                        //   // that.setInterval(blockEnd, true);
                                                        //   this.logVisible = true;
                                                        //   this.refreshLogCount++;
                                                        // }
                                                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                                        // this.router.navigateByUrl('/querybuilder?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executorComp.executor_name + '&version=' + this.selectedVersion);
                                                    }, error => {
                                                        if (this.editFlag) {
                                                            this.eventNameForAudit = 'sqlquery_edit_redeploy_failed';
                                                        } else {
                                                            this.eventNameForAudit = 'sqlquery_create_deploy_failed';
                                                        }
                                                        this.loading = false;
                                                        this.closeNonWSDialogBox();


                                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEPLOYMENT', {
                                                            info: 'Deploying API',
                                                            type: 'error',
                                                            description: 'Unknown error occured.',
                                                            icon: 'fa fa-cloud-upload'
                                                        }, timeStamp, action);

                                                        this.platform.openSnackBar('We are working on the feature to deploy SQL Query APIs onto Cloud... Meanwhile, please validate your designtime business use cases and let us know if you are interested in additional features.', 'Error', {
                                                            duration: 10000,
                                                            verticalPosition: 'top',
                                                            horizontalPosition: 'center'
                                                        });
                                                        let errorMessage = '';
                                                        if (error.error['message']) {
                                                            errorMessage = error.error.message;
                                                        } else {
                                                            let title = '';
                                                            if (this.editFlag) {
                                                                title = 'Error while updating';
                                                            } else {
                                                                title = 'Error while creating';
                                                            }
                                                            this.platform.openSnackBar(error.error, 'Error', {
                                                                duration: 10000,
                                                                verticalPosition: 'top',
                                                                horizontalPosition: 'center'
                                                            });
                                                            errorMessage = error.error;
                                                        }

                                                        Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', this.executorModelPayload, error.status, '', '', errorMessage)).then(response => {
                                                            this.auditListenerService.auditListener.emit({
                                                                type: 'auditLog',
                                                                category: 'isAuditForSQLQuery',
                                                                payload: response
                                                            });
                                                        });
                                                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, this.eventNameForAudit, 'ERROR', error.status, error.statusText, errorMessage, this.executorModelPayload, error, this.router.url)).then(response => {
                                                            const payloadToSend = {
                                                                actions: response
                                                            };
                                                            this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                                                type: 'audit',
                                                                id: localStorage.getItem('IdOfSession'),
                                                                payload: payloadToSend
                                                            });
                                                        });
                                                    });
                                                    this.save = false;
                                                }
                                            });
                                        }, error => {
                                            // this.displaySnackBarWithWS('Error', 5000, 'Error occurred while deploying your SQL API. Please make sure you have selected a valid database.');
                                            this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API DEVELOPMENT', {
                                                info: 'Connecting to the database',
                                                description: 'Error occurred while deploying your SQL API. Please make sure you have selected a valid database.',
                                                type: 'fatal'
                                            }, timeStamp, action);
                                            this.loading = false;
                                            this.closeNonWSDialogBox();
                                            // this.platform.handleErrorGracefully(error, 'Error occurred while deploying your SQL API. Please make sure you have selected a valid database.');
                                        });
                                    } else {
                                        this.loading = false;
                                        this.closeNonWSDialogBox();
                                        // this.displaySnackBarWithWS('Error', 5000, 'Special characters are not allowed in Executor Version');

                                        await this.platform.delay(1500);
                                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                                            info: 'Checking for special characters in Executor version',
                                            type: 'fatal',
                                            description: 'Special characters are not allowed in Executor Version',
                                            icon: 'fa fa-newspaper-o'
                                        }, timeStamp, action);
                                        // this.platform.openSnackBar('Special characters are not allowed in Executor Version', 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                    }
                                } else {
                                    this.loading = false;
                                    this.closeNonWSDialogBox();
                                    // this.displaySnackBarWithWS('Error', 5000, 'Special characters are not allowed in Executor Name');
                                    await this.platform.delay(1500);
                                    this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                                        info: 'Checking for special characters in Executor name',
                                        type: 'fatal',
                                        description: 'Special characters are not allowed in Executor Name',
                                        icon: 'fa fa-newspaper-o'
                                    }, timeStamp, action);
                                    // this.platform.openSnackBar('Special characters are not allowed in Executor Name', 'Error', {
                                    //   duration: 5000,
                                    //   verticalPosition: 'top',
                                    //   horizontalPosition: 'center'
                                    // });
                                }

                                // } else {
                                //   this.loading = false;
                                //   this.platform.openSnackBar('An API with the provided name already exists.', 'Error', {
                                //     duration: 5000,
                                //     verticalPosition: 'top',
                                //     horizontalPosition: 'center'
                                //   });
                                // }
                            }
                        } else {
                            this.loading = false;
                            this.closeNonWSDialogBox();
                        }
                    } else {
                        this.loading = false;
                        this.closeNonWSDialogBox();
                        // this.displaySnackBarWithWS('Error', 5000, 'Special characters are not allowed in Executor version');
                        await this.platform.delay(1500);
                        this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                            info: 'Checking for special characters in Executor version',
                            type: 'fatal',
                            description: 'Special characters are not allowed in Executor version',
                            icon: 'fa fa-newspaper-o'
                        }, timeStamp, action);
                        // this.platform.openSnackBar('Executor version should not have any special characters or spaces in between', 'Error', {
                        //   duration: 10000,
                        //   verticalPosition: 'top',
                        //   horizontalPosition: 'center'
                        // });
                    }
                });
            } else {
                this.loading = false;
                this.closeNonWSDialogBox();
                // this.displaySnackBarWithWS('Error', 5000, 'Special characters are not allowed in Executor name');
                await this.platform.delay(1500);
                this.platform.publishEventMessage(this.executorComp.executor_name, this.executorComp.selectedVersion, 'API REQUIREMENTS', {
                    info: 'Checking for special characters in Executor name',
                    type: 'fatal',
                    description: 'Special characters are not allowed in Executor name',
                    icon: 'fa fa-newspaper-o'
                }, timeStamp, action);
                // this.platform.openSnackBar('Executor name should not have any special characters or spaces in between', 'Error', {
                //   duration: 10000,
                //   verticalPosition: 'top',
                //   horizontalPosition: 'center'
                // });
            }
        });
    }

    runTests() {

        this.testLoading = true;
        this.confPost.testAPITestsuiteWithUsages(this.partner, this.account_id, this.partnerKey, {
            executor_name: this.orig_executor.executor_name,
            executor_version: this.orig_executor.executor_version
        }).subscribe(res => {
            this.testLoading = false;
            if (res) {
                this.testSuiteResponse = res;

                if (this.testSuiteResponse['testCaseResults'] !== undefined) {
                    const dialogRef = this.dialog.open(TestReportComponent, {
                        height: '80%',
                        width: '80%',
                        data: {
                            testSuitePayload: {name: this.testSuiteResponse.name},
                            testSuiteResponse: this.testSuiteResponse
                        }
                    });
                } else {
                    this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
                        duration: 7000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }

        }, error => {
            this.testLoading = false;
            this.platform.handleErrorGracefully(error, 'Error while testing the API. Please try again after sometime.');

        });
    }

    async finishAPIDeployment(executor_name, executor_version, action, timeStamp, result = {completed: true, document: true}) {
        await this.platform.delay(500);
        if (result.completed) {
            if (result.document) {
                this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, timeStamp, action);
                await this.platform.delay(2000);
                this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'success',
                    icon: 'fa fa-book'
                }, timeStamp, action);
            }

            this.orig_executor = JSON.parse(JSON.stringify(this.executorModelPayload));
            await this.platform.delay(1000);
            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.DONE, {
                info: '',
                type: 'success',
                icon: 'fa fa-check'
            }, timeStamp, action);

        }
        this.loading = false;
        this.closeNonWSDialogBox();

    }

    async revertExecutorChanges(executor, executor_name, executor_version, action, timeStamp) {
        this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
            info: 'Reverting changes to API',
            icon: 'fa fa-check-square-o',
            type: 'initial'
        }, timeStamp, action);
        this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account_id, executor['id'], executor).subscribe(async data => {

            if (this.selectedExecutor !== executor.executor_method_type) {
                await this.kongService.updateRouteWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, [executor.executor_method_type], timeStamp, action);
            }

            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'success'
            }, timeStamp, action);
            await this.finishAPIDeployment(executor_name, executor_version, action, timeStamp, {completed: false, document: false});
        }, error => {
            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'fatal'
            }, timeStamp, action);
            this.finishAPIDeployment(executor_name, executor_version, action, timeStamp, {completed: false, document: false});
        });
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    listenAPICreation(timestamp, apiName, apiVersion, action) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, action).subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    listenToApiCreation(topic) {
        this.websocketService.listenToTopic(topic).subscribe(data => {
            if (data) {
                this.currentMessage = JSON.parse(data.body);
            }
        });
    }

    async createOrUpdateApiWithCoreApi(timeStamp, testMode = 'notests') {
        const gateways = this.executorComp.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }
        if (gatewaySettings.length > 0) {
            this.executorModel = {
                'database': {},
                'query': this.code.trim().replace(/\n/g, ' '),
                'paramPrefixSubString': ' :'
            };
            this.databaseName = this.database;
            await this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.databaseName).subscribe(db => {
                if (this.executorComp.selectedExecutorType.toString() === 'SQLQUERY') {
                    if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                        this.executorModel.database['database_name'] = db['database_name'];
                        this.executorModel.database['database_type'] = db['database_type'];
                    }

                    const requestBodyResponse = this.executorComp.getRequestBody();
                    let requestBody = {};
                    if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
                        requestBody = requestBodyResponse['__zone_symbol__value'];
                    } else {
                        requestBody = requestBodyResponse;
                    }
                    const executorModel = {
                        'executor_type': this.executorComp.selectedExecutorType,
                        'executor_name': this.executorComp.executor_name,
                        'executor_version': this.executorComp.selectedVersion,
                        'executor_display_name': this.executorComp.executor_display_name,
                        'executor_description': this.executorComp.description,
                        'executor_category': this.executorComp.executorCategory,
                        'executor_method_type': this.executorComp.selectedExecutor,
                        'published': true,
                        'scopeOfAccess': this.executorComp.scopeSelected,
                        'creationTime': Date.now(),
                        'lastModifiedTime': Date.now(),
                        'registeredAsIs': false,
                        'queryParams': this.executorComp.queryParams,
                        'headers': this.executorComp.headers,
                        'mockResponses': this.executorComp.mockResponses,
                        'authModel': this.executorComp.authModel,
                        'requestBody': requestBody,
                        'prerequisites': this.executorComp.prerequisites,
                        'source': this.code.trim(),
                        'executors': [this.executorModel],
                        'partner': this.partner,
                        'account_id': this.account_id,
                        'apiUrl': this.gatewayFullUrl + '/' + this.executorComp.selectedVersion + '/' + this.executorComp.executor_name,
                        'dataroot': null,
                        // 'responseAttributes': this.executorComp.responseAttributes,
                        'attributeMappings': null,
                        'response': null,
                        'block_attributes': null,
                        'gatewaySettings': gatewaySettings
                    };

                    this.logTimeStamp = timeStamp;

                    const topic = this.partner + '.' + this.account_id + '.' + this.executorComp.executor_name + '.' + this.executorComp.selectedVersion + '.' + timeStamp.toString() + '.' + 'deploy';
                    this.pubSubTopic = topic;
                    this.listenToApiCreation(topic);

                    this.action = 'deploy';
                    const payload = {
                        'topic': topic,
                        'apiModel': executorModel
                    };


                    this.loading = true;
                    if (this.websocketService.isOpen()) {
                        this.logVisible = true;
                    }

                    if (!this.websocketService.isOpen()) {
                        this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                            maxWidth: '95vw',
                            maxHeight: '60vh',
                            data: {
                                message: 'API deployment is under progress. Please don\'t close the window'
                            }
                        });
                    }


                    this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), payload, false, this.editFlag, true, true).toPromise().then(response1 => {

                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                        this.loading = false;
                        if (this.showDialogOnNonWebsocketConnection) {
                            this.showDialogOnNonWebsocketConnection.close();
                        }
                        if (!this.websocketService.isOpen()) {
                            this.logVisible = true;
                            this.refreshLogCount++;
                        }
                        const log_payload = {
                            logType: 'INFO',
                            logLevel: 2,
                            slugSearch: '',
                            label: 'BUTTON_CLICK',
                            featureArea: this.platform.auditFeatureArea.queryBuilder,
                            resource: this.editFlag ? 'REDEPLOY' : 'DEPLOY',
                            action: 'CLICK',
                            result: 'SUCCESS',
                            payload: payload,
                            responseStatusCode: 200,
                            response: response1,
                            errorMessage: '',
                            logMessage: this.editFlag ? 'API Redeployed Successfully' : 'API Deployed Successfully'
                        };
                        this.auditLog.log(log_payload);
                    }, error => {

                        this.loading = false;
                        if (this.showDialogOnNonWebsocketConnection) {
                            this.showDialogOnNonWebsocketConnection.close();
                        }
                        if (!this.websocketService.isOpen()) {
                            this.logVisible = true;
                            this.refreshLogCount++;
                        }
                        const log_payload = {
                            logType: 'ERROR',
                            logLevel: 2,
                            slugSearch: '',
                            label: 'BUTTON_CLICK',
                            featureArea: this.platform.auditFeatureArea.queryBuilder,
                            resource: this.editFlag ? 'REDEPLOY' : 'DEPLOY',
                            action: 'CLICK',
                            result: 'FAIL',
                            payload: payload,
                            responseStatusCode: error.status,
                            response: error,
                            errorMessage: error.message,
                            logMessage: this.editFlag ? 'Error in API Redeployment' : 'Error in API Deployment'
                        };
                        this.auditLog.log(log_payload);
                    });
                }
            }, error1 => {
                this.platform.openSnackBar('Error while retrieving database information.', 'Error', {
                    duration: 7000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.loading = false;
            this.closeNonWSDialogBox();
            this.platform.openSnackBar('Please select at least one valid API Gateway.', 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    async createApiForSqlQuery(testMode = 'notests') {
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;


        this.logComponentRefresh = true;

        if (this.editFlag === true) {
            this.action = 'redeploy';
            this.eventNameForAuditLog = 'REDEPLOY';
            this.eventLabelForAuditLog = this.platform.auditLabels.api_update;
        } else {
            this.action = 'deploy';
            this.eventNameForAuditLog = 'REDEPLOY';
            this.eventLabelForAuditLog = this.platform.auditLabels.api_create;
        }

        this.loading = true;


        this.logVisible = false;
        // if (this.websocketService.isOpen()) {
        //     this.connection = true;
        //     // this.logVisible = true;
        // } else {
        //     this.connection = false;
        // }
        //
        // if (this.connection === false) {
        //     this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
        //         maxWidth: '95vw',
        //         maxHeight: '60vh',
        //         data: {
        //             message: 'API deployment is under progress. Please don\'t close the window'
        //         }
        //     });
        // }
        //
        // Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '1', this.router.url, 'BUTTON_CLICK', this.platform.auditFeatureArea.queryBuilder, 'DEPLOY_BUTTON', 'CLICK', 'SUCCESS', '', 200, '', 'Deploy button clicked')).then(response => {
        //     this.auditListenerService.auditListener.emit({
        //         type: 'auditLog',
        //         category: 'isAuditForSQLQuery',
        //         payload: response
        //     });
        // });

        this.isSqlPresent = false;


        // this.listenAPICreation(timeStamp, this.executorComp.executor_name, this.executorComp.selectedVersion, this.action);

        if ((this.executorComp && !this.executorComp.executor_name)
            || (this.executorComp && !this.executorComp.selectedVersion)
            || (this.executorComp && !this.executorComp.selectedExecutor)
            || (this.executorComp && !this.executorComp.executorCategory)) {

            Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                this.auditListenerService.auditListener.emit({
                    type: 'auditLog',
                    category: 'isAuditForSQLQuery',
                    payload: response
                });
            });
            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loading = false;
            if (this.showDialogOnNonWebsocketConnection) {
                this.showDialogOnNonWebsocketConnection.close();
            }

        } else {
            if (this.database) {
                if (this.code !== null && this.code !== undefined && this.code.length > 0) {
                    this.isSqlPresent = true;
                } else {
                    if (confirm('Are you sure you want to deploy this API without any SQL Statement ?')) {
                        this.isSqlPresent = true;
                    }
                }
                if (this.editFlag === true) {
                    // this.action = 'redeploy';
                    // this.listenAPICreation(this.executorComp.executor_name, this.executorComp.selectedVersion, timeStamp, 'redeploy');
                    this.createOrUpdateApiWithCoreApi(timeStamp);
                    // this.createAPI(timeStamp, testMode);
                } else {
                    // this.action = 'deploy';
                    if (this.executorComp.isAPIAlreadyPresentCheckCompleted === false) {
                        // this.listenAPICreation(this.executorComp.executor_name, this.executorComp.selectedVersion, timeStamp, this.action);

                        await this.executorComp.checkForExistingEntityAndExecutor();
                        if (this.executorComp.isAPIAlreadyPresent === false) {

                            this.createOrUpdateApiWithCoreApi(timeStamp);
                            // this.createAPI(timeStamp);
                        } else {
                            this.loading = false;
                            if (this.showDialogOnNonWebsocketConnection) {
                                this.showDialogOnNonWebsocketConnection.close();
                            }
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'API already exists')).then(response => {
                                this.auditListenerService.auditListener.emit({
                                    type: 'auditLog',
                                    category: 'isAuditForSQLQuery',
                                    payload: response
                                });
                            });
                        }
                    }
                }
            } else {
                Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.queryBuilder, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid database selection')).then(response => {
                    this.auditListenerService.auditListener.emit({
                        type: 'auditLog',
                        category: 'isAuditForSQLQuery',
                        payload: response
                    });
                });
                this.platform.openSnackBar('Select a valid database connection.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
            }
        }
    }


    executeSqlStatement(query) {
        if (this.database && this.database !== undefined && this.database !== null) {
            if (this.code !== null && this.code !== undefined && this.code !== '') {
                this.itemList = [];
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'sqlquery_statement_execute_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.SQLQueryListenerInstance.sqlQueryListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.responseCode = '';
                this.responseData = '';
                this.errorMessage = '';
                this.responseError = '';
                this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.database).subscribe(db => {
                    const cursorPosition = this.editor.getEditor().getCursorPosition();
                    query = this.editor.getEditor().getSession().getLine(cursorPosition.row);
                    const executorModel = {
                        'database': {},
                        'query': query.trim().replace(/\n/g, ' '),
                        'paramPrefixSubString': ' :'
                    };
                    if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                        executorModel.database['database_name'] = db['database_name'];
                        executorModel.database['database_type'] = db['database_type'];
                    }
                    const payload = this.getAPIExecutorModelForSQLQuery(executorModel);
                    const startTime = performance.now();
                    this._service.executeApiV2(payload).subscribe(result => {
                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'sqlquery_statement_execute_success', 'INFO', result.status, result.statusText, '', payload, '', this.router.url)).then(response => {
                                const payloadToSend = {
                                    actions: response,
                                };
                                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                    type: 'audit',
                                    id: localStorage.getItem('IdOfSession'),
                                    payload: payloadToSend
                                });
                            });
                            const endTime = performance.now();
                            this.responses = result.body;
                            this.responseItems = this.responses.body;
                            this.responseCode = this.responseItems.statusCode;
                            if (this.responseCode >= 400) {
                                this.error = true;
                            } else {
                                this.error = false;
                            }
                            if (this.responseItems.attributes !== null && this.responseItems.attributes !== undefined) {
                                for (let i = 0; i < this.responseItems.attributes.length; i++) {
                                    let tempObj = {};
                                    tempObj['id'] = i + 1;
                                    tempObj['itemName'] = this.responseItems.attributes[i]['attributeName'];
                                    this.itemList.push(tempObj);
                                }
                            }
                            if (this.error) {
                                if (this.responseItems.body) {
                                    this.erroResponse = JSON.parse(this.responseItems.body);
                                    this.errorMessage = 'Current SQL Statement: ' + query + ' => ' + this.erroResponse[0].message;
                                } else {
                                    this.errorMessage = 'Current SQL Statement: ' + query + ' => ' + this.responseItems.message;
                                    if (this.responseItems.error) {
                                        this.responseError = this.responseItems.error;
                                    }
                                }
                            } else {
                                if (this.responseItems.body) {
                                    this.responseData = JSON.parse(this.responseItems.body);
                                    for (const item of this.responseData) {
                                        this.columns = [];
                                        for (const itemval in item) {
                                            this.columns.push(itemval);
                                        }
                                    }
                                }
                            }
                            this.responseTime = Math.round(endTime - startTime);

                        },
                        error => {
                            let errorMessage = '';
                            if (error.error['message']) {
                                errorMessage = error.error.message;
                            } else {
                                errorMessage = error.error;
                            }
                            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'sqlquery_statement_execute_failed', 'ERROR', error.status, error.statusText, errorMessage, payload, error, this.router.url)).then(response => {
                                const payloadToSend = {
                                    actions: response
                                };
                                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                                    type: 'audit',
                                    id: localStorage.getItem('IdOfSession'),
                                    payload: payloadToSend
                                });
                            });
                            this.responseCode = 404;
                            if (error && error.error && error.error !== null && error.error !== undefined && error.error.body && error.error.body !== undefined) {
                                this.errorMessage = error.error.body;
                            } else {
                                this.errorMessage = 'Error while executing query: ' + query + '. Please check the SQL Query and Database connection.';
                            }
                            this.responseError = 'SQL Error';
                            // }
                            this.error = true;

                        });


                }, error => {
                    this.platform.openSnackBar('The database you selected does not exist', 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
            else {
                this.platform.openSnackBar('Please enter a valid SQL Statement to execute', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Please select a valid database connection to execute the SQL statement', 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }

    }

    executeSQLStatement(db, query, startTime) {
        return new Promise((resolve, reject) => {
            this.responseItems = '';
            this.responseCode = '';
            this.responseData = '';
            this.errorMessage = '';
            this.responseError = '';

            const executorModel = {
                'database': {},
                'query': query.trim().replace(/\n/g, ' '),
                'paramPrefixSubString': ' :'
            };
            if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                executorModel.database['database_name'] = db['database_name'];
                executorModel.database['database_type'] = db['database_type'];
            }

            const payload = this.getAPIExecutorModelForSQLQuery(executorModel);

            this._service.executeApiV2(payload).subscribe(result => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'sqlquery_script_execute_success', 'INFO', result.status, result.statusText, '', payload, '', this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.SQLQueryListenerInstance.sqlQueryListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    const endTime = performance.now();
                    this.responses = result.body;
                    this.responseItems = this.responses.body;
                    this.responseCode = this.responseItems.statusCode;
                    if (this.responseCode >= 400) {
                        this.error = true;
                    } else {
                        this.error = false;
                    }
                    if (this.responseItems.attributes !== null && this.responseItems.attributes !== undefined) {
                        for (let i = 0; i < this.responseItems.attributes.length; i++) {
                            let tempObj = {};
                            tempObj['id'] = i + 1;
                            tempObj['itemName'] = this.responseItems.attributes[i]['attributeName'];
                            this.itemList.push(tempObj);
                        }
                    }
                    if (this.error) {
                        if (this.responseItems.body) {
                            this.erroResponse = JSON.parse(this.responseItems.body);
                            this.errorMessage = 'Current SQL Statement: ' + query + ' => ' + this.erroResponse[0].message;
                        } else {
                            this.errorMessage = 'Current SQL Statement: ' + query + ' => ' + this.responseItems.message;
                            if (this.responseItems.error) {
                                this.responseError = this.responseItems.error;
                            }
                        }
                        reject('failed');
                    } else {
                        if (this.responseItems.body) {
                            this.responseData = JSON.parse(this.responseItems.body);
                            for (const item of this.responseData) {
                                this.columns = [];
                                for (const itemval in item) {
                                    this.columns.push(itemval);
                                }
                            }
                        }
                        resolve('success');
                    }
                    this.responseTime = Math.round(endTime - startTime);


                },
                error => {
                    let errorMessage = '';
                    if (error.error['message']) {
                        errorMessage = error.error.message;
                    } else {
                        errorMessage = error.error;
                    }
                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'sqlquery_script_execute_failed', 'ERROR', error.status, error.statusText, errorMessage, payload, error, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.SQLQueryListenerInstance.sqlQueryListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.responseCode = 404;
                    if (error && error.error && error.error !== null && error.error !== undefined && error.error.body && error.error.body !== undefined) {
                        this.errorMessage = error.error.body;
                    } else {
                        this.errorMessage = 'Error while executing query: ' + query + '. Please check the SQL Query and Database connection.';
                    }
                    this.responseError = 'SQL Error';
                    // }
                    this.error = true;
                    reject('failed');
                    return;
                });
        });
    }

    executeSqlScript() {
        if (this.database && this.database !== undefined && this.database !== null) {
            this.itemList = [];
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'sqlquery_script_execute_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.SQLQueryListenerInstance.sqlQueryListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            const startTime = performance.now();
            this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.database).subscribe(async db => {
                const statementArray = this.code.trim().split(';');
                let stopExecution = false;
                // statementArray.forEach(async query => {
                if (statementArray && statementArray.length > 0) {
                    for (let i = 0; i < statementArray.length; i++) {
                        if (statementArray[i] && statementArray[i] !== null && statementArray[i] !== undefined) {
                            const query = statementArray[i];
                            if (query.trim() !== null && query.trim() !== undefined && query.trim() !== '') {
                                if (stopExecution === false) {
                                    await this.executeSQLStatement(db, query, startTime).then(response => {

                                    }, onRejected => {
                                        stopExecution = true;
                                    });
                                } else {
                                    break;
                                }
                            }
                        }
                    }
                }
                // });
            }, error => {
                this.platform.openSnackBar('The database you selected does not exist', 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
            return this.responseCode;
        } else {
            this.platform.openSnackBar('Please select a valid database connection to execute the SQL statement', 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    download() {
        $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
        this.saveAsProject();
    }

    saveAsProject() {
        //you can enter your own file name and extension
        if (this.responseData !== null && this.responseData !== undefined) {
            const data = this.responseData;
            const fileName = 'download';
            const exportType = 'json';
            exportFromJSON({data, fileName, exportType});
        }
    }

    getStatusCodeStyle(val) {
        if (val < 400) {
            return 'status-ok';
        } else {
            return 'status-not-ok';
        }
    }

    stringifyjson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    typeOfval(val) {
        return typeof val;
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    manageProgress(target, showPanel) {
        if (this.progress <= 20) {
            this.loading = false;
            this.closeNonWSDialogBox();
            // this.showNextPanel = showPanel;
            // this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            //   let item = data;
            // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
            let apiKey = localStorage.getItem('apikey');
            const dialogRef = this.dialog.open(DialogComponent, {
                maxWidth: '95vw',
                data: {
                    type: 'bl',
                    save: true,
                    gatewayFullUrl: this.gatewayFullUrl,
                    Blocks: this.Blocks,
                    selectedVersion: this.selectedVersion,
                    showNextPanel: false,
                    partner: this.partner,
                    account: this.account_id,
                    selectedExecutor: this.selectedExecutor,
                    executor_name: this.executor_name,
                    apiKey: apiKey,
                    partnerKey: this.partnerKey
                }
            });
            dialogRef.afterClosed().subscribe(async result => {
                if (result === 'create') {
                    this.save = false;
                    await this.router.navigateByUrl('/querybuilder');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (result === 'edit') {
                    this.save = false;
                    this.router.navigateByUrl('/querybuilder?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                } else if (result === 'execute') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion);
                } else if (result === 'devex') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion + '&showDoc=true');
                }
            });
            // });
            // });
            this.ngOnDestroy();
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up Business Logic API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
            /*} else if (this.progress > 70 && this.progress <= 98) {
                this.progressMessage = 'Creating dedicated File storage for your account';*/
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    copyMessage(event) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(event.target).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    parameterDataCheck(event: any) {
        // /: calculation
        // this.devExURL = event.target.value;

        var queryParameterSegregator = this.code.trim().replace(/\n/g, ' ').split(' :');
        this.selectedIndex = 2;
        var queryParameterStopper;
        var find = false;
        for (let i = 1; i < queryParameterSegregator.length; i++) {
            if (queryParameterSegregator[i] !== '') {
                queryParameterStopper = queryParameterSegregator[i].split(' ');
                queryParameterSegregator[i] = queryParameterStopper[0];
            }
        }
        for (let i = 1; i < queryParameterSegregator.length; i++) {
            if (queryParameterSegregator[i] !== '') {
                find = true;

                for (let j = 0; j < this.executorComp.queryParams.length; j++) {
                    if (queryParameterSegregator[i] === this.executorComp.queryParams[j]['key']) {
                        find = false;
                    }
                }
            }
        }

        var find = false;
        for (let i = 1; i < queryParameterSegregator.length; i++) {
            if (queryParameterSegregator[i] !== '') {
                queryParameterStopper = queryParameterSegregator[i].split(';');
                queryParameterSegregator[i] = queryParameterStopper[0];
            }
        }
        for (let i = 1; i < queryParameterSegregator.length; i++) {
            if (queryParameterSegregator[i] !== '') {
                find = true;
                for (let j = 0; j < this.executorComp.queryParams.length; j++) {
                    if (queryParameterSegregator[i] === this.executorComp.queryParams[j]['key']) {
                        find = false;
                    }
                }
            }
        }

        var find = false;
        for (let i = 1; i < queryParameterSegregator.length; i++) {
            if (queryParameterSegregator[i] !== '') {
                queryParameterStopper = queryParameterSegregator[i].split('/\n/g');
                queryParameterSegregator[i] = queryParameterStopper[0];
            }
        }
        for (let i = 1; i < queryParameterSegregator.length; i++) {
            if (queryParameterSegregator[i] !== '') {
                find = true;
                for (let j = 0; j < this.executorComp.queryParams.length; j++) {
                    if (queryParameterSegregator[i] === this.executorComp.queryParams[j]['key']) {
                        find = false;
                    }
                }
            }
        }


        var alreadyAdded = false;

        const existingKeyValues = {};

        if (this.executorComp.queryParams.length > 0) {
            for (const param of this.executorComp.queryParams) {
                if (param) {
                    existingKeyValues[param['key']] = param['value'];
                }
            }
        }

        this.executorComp.queryParams = [];
        for (let k = 1; k < queryParameterSegregator.length; k++) {
            if (queryParameterSegregator[k] !== '') {
                this.executorComp.queryParams.forEach(param => {
                    if (param.key === queryParameterSegregator[k].replace('\'', '')) {
                        alreadyAdded = true;
                        find = false;
                        return;
                    }
                });
                if (!alreadyAdded) {
                    this.executorComp.queryParams.push({
                        'key': queryParameterSegregator[k].replace('\'', ''),
                        'value': '',
                        'description': ''
                    });
                }
                if (this.executorComp.isToggleExpanded === false) {
                    this.executorComp.toggleExecutor(event);
                    this.executorComp.toggleFlag = true;
                }
                alreadyAdded = false;
            }
        }

        for (const param of this.executorComp.queryParams) {
            if (param) {
                param['value'] = this.getValueFromExistingParams(existingKeyValues, param['key']);
            }
        }

    }

    getValueFromExistingParams(existingValues, key) {
        if (existingValues.hasOwnProperty(key)) {
            return existingValues[key];
        } else {
            return '';
        }
    }

    generateExecutorAgain() {
        window.location.reload();
    }

    createMarginRight() {
        document.getElementById('view:querybuilderbase').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:querybuilderbase').style.marginRight = '0px';
    }
}
